import { Controller } from "@hotwired/stimulus"

// "Not now" on a contact card's alert (contacts/_alerts). Remembered in this
// browser only: the signal itself stays where it came from - the memory queue,
// their work history - so dismissing it here hides the prompt without settling
// anything. Keyed per alert, so a NEW conflict on the same card still shows.
const STORE = "emailpa-card-alerts-dismissed"

export default class extends Controller {
    static values = { key: String }

    connect() {
        if (this._dismissed().includes(this.keyValue)) this.element.hidden = true
    }

    dismiss() {
        this.element.hidden = true
        const keys = new Set(this._dismissed())
        keys.add(this.keyValue)
        try {
            window.localStorage.setItem(STORE, JSON.stringify([...keys].slice(-200)))
        } catch (_error) {
            /* a private window still hides it, it just forgets */
        }
    }

    _dismissed() {
        try {
            const saved = JSON.parse(window.localStorage.getItem(STORE) || "[]")
            return Array.isArray(saved) ? saved : []
        } catch (_error) {
            return []
        }
    }
}
